<script>


export default {
    props: {
        setLabel: String,
        setLabelRow: String,
        switchValue: {
            type: Boolean,
            default: false,
        },
        colorChecked: {
          type: String,
          default: '#161a46',
        },
        colorUnchecked: {
          type: String,
          default: 'var(--grey-6)',
        },
    },
};
</script>

<template>
  <div :style="setLabelRow ? 'display: flex' : 'display: block'" class="inputContent">
    <label v-if="setLabel || setLabelRow" :for="setLabel">{{ setLabel || setLabelRow }}</label>
    <label class="toggleSwitch">
      <input
        :id="setLabel"
        @change="$emit('switchClicked', switchValue = !switchValue)"
        type="checkbox"
        :checked="switchValue"
      />
      <span :style="{ backgroundColor: switchValue ? colorChecked : colorUnchecked }" class="knob"></span>
    </label>
  </div>
</template>

<style scoped>

.inputContent {
    gap: 0.5rem;
    align-items: center;
}

.toggleSwitch input {
    min-height: auto;
    margin: 0px;
}

</style>